import React from "react";

export default function ErrorView(props: any) {
  if (props.error && "production" !== process.env.NODE_ENV) {
    return <p>Error: {JSON.stringify(props.error)}</p>;
  }

  return (
    <h3>
      Leider ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch
      einmal.
    </h3>
  );
}
